import { TipeeeIcon } from '../icons/tipeee.icon';

export function Donation() {
  return (
    <a
      className="bg-mo5-accent text-white flex gap-3 hover:text-yellow-400 transition-colors duration-300 rounded-md px-3 items-center mx-4 mt-1"
      href="https://fr.tipeee.com/association-mo5-com"
      target="_blank"
      rel="noreferrer"
    >
      <div className="flex items-center">
        <TipeeeIcon />
      </div>
      <div className="flex items-center h-full">
        <div className="text-centered leading-1 text-2xl pt-1">Rejoindre L'association</div>
      </div>
    </a>
  );
}
